<template>
  <div>
    <div class="m-b-10" v-if="label">{{label}}</div>
    <a-select
      show-search
      allowClear
      :placeholder="placeholder"
      style="width: 100%;"
      :filter-option="false"
      @search="searchOption"
      @change="handleChange"
      :isToggleModel="isToggleModel"
      v-model="gdObjectId"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option
        v-for="s in selectData"
        :key="s.objectId"
      >
        {{s.name}}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  name: 'searchInput',
  props: {
    label: String,
    placeholder: String,
    className: String,
    listWhere: Object,
    objectId: String,
    isToggleModel: Boolean
  },
  data () {
    return {
      fetching: false,
      selectData: [],
      gdObjectId: this.objectId
    }
  },
  watch: {
    listWhere (val) {
      this.getInit()
    },
    objectId () {
      this.gdObjectId = this.objectId
    },
    isToggleModel () {
      this.getInit()
    }
  },
  mounted () {
    this.getInit()
  },
  methods: {
    async getInit () {
      this.selectData = []
      let res = await this.$tkParse.getList(`/classes/${this.className}`, {
        params: {
          limit: 10,
          where: this.listWhere
        }
      })
      if (res.length) { this.selectData = res } else { this.selectData = [] }
    },
    async searchOption (value) {
      if (!value) {
        if (this.listWhere.name) { delete this.listWhere.name }
        await this.getInit()
        return
      }
      this.fetching = true
      this.selectData = []
      this.listWhere.name = { $regex: value }
      let res = await this.$tkParse.getList(`/classes/${this.className}`, {
        params: {
          limit: 100,
          where: this.listWhere
        }
      }).catch(e => {
        this.fetching = false
      })
      if (res.length) { this.selectData = res } else {
        this.selectData = []
      }
      this.fetching = false
    },
    handleChange (value) {
      this.$emit('changeVal', value)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
